import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AppService } from '../../../../../core/app.service';
import { TableModePassation } from '../../../../../data/schemas/table.schema';
import { UiTable } from '../../../../../components/ui/table/table.component';
import { ModalComponent } from '../../../../../components/modal/modal.component';
import { LoaderComponent } from '../../../../../components/ui/loader/loader.component';
import { Input } from '../../../../../components/forms/input/input';

@Component({
  selector: 'app-modepassation',
  imports: [UiTable, ModalComponent, ReactiveFormsModule, LoaderComponent, Input],
  templateUrl: './modepassation.component.html',
  styleUrl: './modepassation.component.css'
})
export class ModepassationPageComponent {
  constructor(
    private appService: AppService,
    private fb: FormBuilder
  ){
    this.modePassationForm = this.fb.group({
      applicationId: this.appService.getAppId(),
      libelle: ['', [Validators.required]],
    });
  }

  public tableModePassation = TableModePassation
  public showAddModePassationModal: boolean = false;
  public modePassations : any[] = []
  public isLoading: boolean = false;
  public isEditing: boolean = false; // Nouvelle propriété pour suivre l'état d'édition
  public editingModePassation: any | null = null;

  modePassationForm!: FormGroup;

  saveModePassation(): void {
      
  }

  onEditModePassation(item: any): void {
    this.isEditing = true;
    this.editingModePassation = item;
    this.modePassationForm.patchValue({
      libelle: item.libelle,
      applicationId: this.appService.getAppId()
    });
    this.showAddModePassationModal = true;
  }

  openModePassationModal(): void {
    this.isEditing = false; // S'assurer que nous sommes en mode ajout
    this.editingModePassation = null;
    this.modePassationForm.reset({
      applicationId: this.appService.getAppId(),
      libelle: ''
    }); // Réinitialiser le formulaire
    this.showAddModePassationModal = true;
  }

  closeModePassationModal(): void {
    this.showAddModePassationModal = false;
    this.isEditing = false; // Réinitialiser l'état d'édition
    this.editingModePassation = null; // Réinitialiser l'élément en édition
    this.modePassationForm.reset({
      applicationId: this.appService.getAppId(),
      libelle: ''
    });
  }
  
  onDeleteModePassation(item: any): void {
    
  }
}
